import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import apiUrl from "../../services/api";

// Async thunk for saving partner info
export const savePartnerInfo = createAsyncThunk(
  "partner/savePartnerInfo", // action type prefix
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(apiUrl.savePartnerInfo, payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Contact us failed");
    }
  }
);

export const saveStudentLeadInfo = createAsyncThunk(
  "partner/saveStudentLeadInfo", 
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(apiUrl.saveStudentLEadInfo, payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Contact us failed");
    }
  }
);

const initialState = {
  user: null,
  loading: false,
  error: null,
  isLoggedIn: false, // added since you use it in reducers
};

const partnerSlice = createSlice({
  name: "partner",
  initialState,
  reducers: {
    resetStatus : (state) => {
      state.user = null;
      state.isLoggedIn = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(savePartnerInfo.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(savePartnerInfo.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload;
        state.isLoggedIn = true;
      })
      .addCase(savePartnerInfo.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.isLoggedIn = false;
      })
      .addCase(saveStudentLeadInfo.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(saveStudentLeadInfo.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload;
        state.success = true;
      })
      .addCase(saveStudentLeadInfo.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      });
  },
});

export const { resetStatus  } = partnerSlice.actions;
export default partnerSlice.reducer;
